module.exports = __webpack_public_path__ + "static/media/networkingM.8f75bb1c.jpg";